import React from 'react';
import { state, Beep } from 'react-beep';
import Snackbar from 'microcomponents/snackbar';

class Snack extends Beep(['snackbarOpen']) {
  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    state.snackbarOpen = false;
  };
  render() {
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={state.snackbarOpen}
        autoHideDuration={4000}
        onClose={this.handleCloseSnackbar}
        variant={state.snackbarType}
        message={state.snackbarText}
      />
    );
  }
}

export default Snack;
